import { useIntl, Text, BackgroundImage } from 'platform-components';
import React from 'react';

import { SidePanelHeader } from '../__header/side-panel__header';

export const SidePanelModeCopyAsRno = () => {
    const intl = useIntl();
    const copyingLoaderUrl = intl.formatMessage({ id: 'lessonModal.cover.copying.loaderUrl' });

    return (
        <>
            <SidePanelHeader>
                <Text id="lessonView.sidePanel.copy.title.RNO" size={Text.SIZE.XL} weight={Text.WEIGHT.M} />
            </SidePanelHeader>
            <div className="side-panel__content">
                <BackgroundImage mix="side-panel__copying-loader" objectFit="cover" src={copyingLoaderUrl} />
            </div>
        </>
    );
};
